import { create } from "zustand";

interface SpritesheetState {
  avatarsReady: boolean;
  setAvatarsReady: (ready: boolean) => void;
}

export const useSpritesheetStore = create<SpritesheetState>((set) => ({
  avatarsReady: false,
  setAvatarsReady: (ready) => set({ avatarsReady: ready }),
}));

